import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

export const TestatorMemberDataSchema = z.object({
  testamentRole: z.enum(['mainTestator', 'spouse']),
  birthRegistryOffice: z
    .string({
      message: 'Standesamt ist verpflichtend',
    })
    .min(1, 'Standesamt ist verpflichtend'),
  birthRegistrationNumber: z
    .string({ message: 'Geburtsregisternummer ist verpflichtend' })
    .min(1, 'Geburtsregisternummer ist verpflichtend'),
});

export type IMemberTestatorData = z.infer<typeof TestatorMemberDataSchema>;

export const TestatorMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Testator),
    TestatorMemberDataSchema
  );

export type IMemberTestator = z.infer<typeof TestatorMemberSchema>;

export const getEmptyTestatorMemberData = (
  testamentRole: IMemberTestatorData['testamentRole']
): IMemberTestatorData => ({
  testamentRole,
  birthRegistryOffice: '',
  birthRegistrationNumber: '',
});

export const getEmptyTestatorMember = (
  legalClient: ILegalClient,
  idRelationship: number,
  data?: IMemberTestatorData
): IMemberTestator => {
  const member: IMemberTestator = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Testator,
    data: data || getEmptyTestatorMemberData('mainTestator'),
  };
  return member;
};
